import * as React from "react";

interface Props {
  questionId: number;
  value: number;
  onChange: (value: number) => void;
}

export default function StarRating(props: Props) {
  const [value, setValue] = React.useState(props.value);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  function renderStar(num: number) {
    return (
      <span
        className={value >= num ? "star full" : "star"}
        tabIndex={0}
        onClick={() => props.onChange(num)}
        onKeyDown={e => {
          return e.keyCode !== 13 || props.onChange(num);
        }}
        onMouseEnter={() => {
          setValue(num);
        }}
        onMouseLeave={() => {
          setValue(props.value);
        }}
        role="button"
        aria-label={`${num} Star Rating`}
        aria-describedby={`velaro-survey-question-label-${props.questionId}`}
        aria-pressed={value >= num}
      >
        {String.fromCharCode(9733)}
      </span>
    );
  }

  return (
    <span tabIndex={0} className="velaro-rating-component">
      {renderStar(1)}
      {renderStar(2)}
      {renderStar(3)}
      {renderStar(4)}
      {renderStar(5)}
    </span>
  );
}
